if (!customElements.get("date-countdown")) {
  customElements.define(
    "date-countdown",
    class Countdown extends HTMLElement {
      constructor() {
        super()

        this.elements = {
          countdownWrapper: this.querySelector("[data-countdown]"),
        }

        this.countDown(this)
      }

      countDown(container) {
        this.container = container

        const counter = this.elements.countdownWrapper
        const dateValue = counter.dataset.date

        // Variables para almacenar los valores previos
        let prevValues = {
          remainDays: null,
          remainHours: null,
          remainMin: null,
          remainSec: null,
          timeDayClass: null,
        }

        // Referencias a los elementos DOM para actualizaciones selectivas
        let domElements = {}

        const getRemainTime = (deadLine) => {
          let now = new Date(),
            remainTime = (new Date(deadLine) - now + 1000) / 1000,
            remainSec = ("0" + Math.floor(remainTime % 60)).slice(-2),
            remainMin = ("0" + Math.floor((remainTime / 60) % 60)).slice(-2),
            remainHours = ("0" + Math.floor((remainTime / 3600) % 24)).slice(-2),
            remainDays = Math.floor(remainTime / (3600 * 24))

          return {
            remainTime,
            remainSec,
            remainMin,
            remainHours,
            remainDays,
          }
        }

        const createCountdownStructure = (time, timeDayClass) => {
          return `<div class="countdown-item ${timeDayClass}"><span class=" countdown__eachDate countdown__eachDateFirst" data-time="days">${time.remainDays}</span><span class="countdown-format">días</span></div><span class="countdown-separator">:</span><div class="countdown-item"><span class="countdown__eachDate" data-time="hours">${time.remainHours}</span><span class="countdown-format">horas</span></div><span class="countdown-separator">:</span><div class="countdown-item"><span class="countdown__eachDate" data-time="minutes">${time.remainMin}</span><span class="countdown-format">minutos</span></div><span class="countdown-separator">:</span><div class="countdown-item"><span class="countdown__eachDate countdown__eachDateLast" data-time="seconds">${time.remainSec}</span><span class="countdown-format">segundos</span></div>`
        }

        const updateSelectiveElements = (time, timeDayClass) => {
          // Actualizar días solo si cambió el valor o la clase
          if (prevValues.remainDays !== time.remainDays || prevValues.timeDayClass !== timeDayClass) {
            if (domElements.days) {
              domElements.days.textContent = time.remainDays
              domElements.daysContainer.className = `countdown-item ${timeDayClass}`
            }
            prevValues.remainDays = time.remainDays
            prevValues.timeDayClass = timeDayClass
          }

          // Actualizar horas solo si cambió
          if (prevValues.remainHours !== time.remainHours) {
            if (domElements.hours) {
              domElements.hours.textContent = time.remainHours
            }
            prevValues.remainHours = time.remainHours
          }

          // Actualizar minutos solo si cambió
          if (prevValues.remainMin !== time.remainMin) {
            if (domElements.minutes) {
              domElements.minutes.textContent = time.remainMin
            }
            prevValues.remainMin = time.remainMin
          }

          // Actualizar segundos solo si cambió
          if (prevValues.remainSec !== time.remainSec) {
            if (domElements.seconds) {
              domElements.seconds.textContent = time.remainSec
            }
            prevValues.remainSec = time.remainSec
          }
        }

        let timeUpDate
        function countDown(deadLine, elem) {
          let timeDay = getRemainTime(deadLine)
          var timeDayClass = ""

          if (timeDay.remainDays < 1) {
            var timeDayClass = "hide"
          }

          counter.classList.add("countdown-active")

          // Renderizado inicial
          elem.innerHTML = createCountdownStructure(timeDay, timeDayClass)

          // Obtener referencias DOM
          domElements = {
            days: elem.querySelector('[data-time="days"]'),
            hours: elem.querySelector('[data-time="hours"]'),
            minutes: elem.querySelector('[data-time="minutes"]'),
            seconds: elem.querySelector('[data-time="seconds"]'),
            daysContainer: elem.querySelector(".countdown-item"),
          }

          // Establecer valores iniciales
          prevValues = {
            remainDays: timeDay.remainDays,
            remainHours: timeDay.remainHours,
            remainMin: timeDay.remainMin,
            remainSec: timeDay.remainSec,
            timeDayClass: timeDayClass,
          }

          timeUpDate = setInterval(function () {
            let time = getRemainTime(deadLine)
            let currentTimeDayClass = time.remainDays < 1 ? "hide" : ""

            if (time.remainTime < 1) {
              clearInterval(timeUpDate)
            }

            if (
              (time.remainDays < 0 && time.remainHours < 0 && time.remainMin < 0) ||
              (time.remainDays <= 0 && time.remainHours <= 0 && time.remainMin <= 0 && time.remainSec <= 0)
            ) {
              // Solo renderizar cuando termine el countdown
              elem.innerHTML = `<div class="countdown-item ${currentTimeDayClass}"><span class=" countdown__eachDate countdown__eachDateFirst">00</span><span class="countdown-format">días</span></div><span class="countdown-separator">:</span><div class="countdown-item"><span class="countdown__eachDate">00</span><span class="countdown-format">horas</span></div><span class="countdown-separator">:</span><div class="countdown-item"><span class="countdown__eachDate">00</span><span class="countdown-format">minutos</span></div><span class="countdown-separator">:</span><div class="countdown-item"><span class="countdown__eachDate countdown__eachDateLast">00</span><span class="countdown-format">segundos</span></div>`
              counter.classList.add("finish")
            } else {
              // Actualización selectiva de elementos
              updateSelectiveElements(time, currentTimeDayClass)
            }
          }, 1000)
        }

        countDown(dateValue, counter)
      }
    }
  )
}
